import { Alert, styled } from '@mui/material';

export const WarningAlertStyled = styled(Alert)({
  color: '#FF981F',
  background: '#FFF4E5',
  minHeight: '48px',
  display: 'flex',
  '.MuiAlert-message': {
    display: 'flex',
    alignItems: 'center',
  },
});
